import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { useSelector } from "react-redux";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "../../BankAccountList.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditBankAccount from "../../../AddEditBankAccount";
import "../../BankAccountList.scss";
import UserInfo from "@utils/UserInfo";

const Action = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isAddAccountPopupVisible, setAddAccountPopupVisible] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);

  const userInfo = UserInfo.getUser();
  const handleDisable = () => {
    setConfirmVisibility(true);
  };

  const editAccount = () => {
    setAddAccountPopupVisible(true);
  };
  const closeAccountCreationPopup = () => {
    setAddAccountPopupVisible(false);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };
  useEffect(() => {
    if (isConfirm) {
      const formStatus = data.isActive ? "0" : 1;
      if (data.isActive === 1) {
        axios
          .delete(`/general/bankAccounts/${data.id}`)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => {
            onRefreshData(true);
            handleApiError(error);
          });
      } else {
        axios
          .put(`/general/bankAccounts/${data.id}`, {
            ...data,
            country: JSON.stringify(data.country),
            createdBy: JSON.stringify({ id: userInfo.id }),
            updatedBy: JSON.stringify({ id: userInfo.id }),
            isActive: formStatus,
          })
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => {
            onRefreshData(true);
            handleApiError(error);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <ButtonContainer>
      <div>
        <Image
          src={editIcon}
          onClick={editAccount}
          title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          className="bankAccount-list__image-icon"
        />
        {data.isActive == 1 && (
          <Image
            src={deleteIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            title={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            className="bankAccount-list__image-icon"
          />
        )}
        {data.isActive == 0 && (
          <Image
            src={activateIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            title={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            className="bankAccount-list__image-icon"
          />
        )}
      </div>

      {isAddAccountPopupVisible && (
        <AddEditBankAccount
          title={t("BANK_ACCOUNT")}
          onClose={closeAccountCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          selectedAccount={data}
          isEditMode
          id={data.id}
        />
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={
            data.isActive == 0
              ? t("BANK_ACCOUNT_CONFIRMATION_BOX_ENABLE")
              : t("BANK_ACCOUNT_CONFIRMATION_BOX_DELETE")
          }
          message={
            data.isActive == 0
              ? t("BANK_ACCOUNT_CONFIRMATION_BOX_ENABLE_CONTENT")
              : t("BANK_ACCOUNT_CONFIRMATION_BOX_DELETE_CONTENT")
          }
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

Action.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(Action);
